import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { Company } from '../../Models/Models/Customer/Company';
import { CompanyActorId } from '../../Models/Models/Customer/CompanyActorId';

declare var IS_RUNNING_IN_APP_POOL;

export class CompanyActorClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Company, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CompanyActor/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Company, any>(url, data);
  }
  public put(customerId: number, company: Company): Promise<Company, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CompanyActor/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, company: company }

    return AjaxWrapper.put<Company, any>(url, data);
  }
  public post(ownerAdviserId: number, company: Company): Promise<CompanyActorId, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CompanyActor/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { ownerAdviserId: ownerAdviserId, company: company }

    return AjaxWrapper.post<CompanyActorId, any>(url, data);
  }
}

